
import searchBlock from "@/components/searchBlock.vue";

import Group from 'vux/src/components/group/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

export default {
name: "search",
components: {
Search,
XInput,
Icon,
Group,
searchBlock
},
data() {
return {
iconNone: require("@/assets/image/icon/dele.png"),
iconPlay: require("@/assets/image/icon/icon_play.png"),
imgNull: require("@/assets/image/icon/icon_null.png"),
serchKey: "", //搜索詞
hotKeys: [],
searchData: [],
isNative: false
};
},
methods: {
inputChange(e) {

if (e.length <= 1) {
this.searchData = [];
}
},

onClickLeft(){
this.$router.go(-1)
},

doSearch() {
if (this.serchKey.length < 1) {
this.$toast.text(this.$t("SEARCH_LANG.inputTexas"));
return;
}

let postD = {
keyword: this.serchKey
};

this.$toast.loading();

this.GLOBAL_.ccRequest.doAxios(this.CONFIG.COLUMN.SEARCHBYKEYWORD, postD, "GET")
.then(res => {


this.$toast.close();
let arr = [];

res.forEach(v => {
if (v.total > 0) {
arr.push(v);
}
});


this.searchData = arr;
})
.catch(err => {
this.$toast.text(this.$t("SEARCH_LANG.searchErr"));
});
}
},
created() {
console.log('this.serchKey0c',this.serchKey);
},
mounted() {
console.log('src',this.$route.query.src);
},
beforeRouteLeave(to, from, next) {
console.log('to', to, from);
let _this = this;
if(to.path == '/home') {
from.meta.keepAlive = false
}else{
from.meta.keepAlive = true
}
next();
}
};



// WEBPACK FOOTER //
// ./src/pages/search/search.vue